<script lang="ts">
  import { t } from '$core/i18n';
  import { joinGroupByCode } from '$features/social';
  import { Modal } from '$ui/primitives/Modal';
  import { Button } from '$ui/primitives/Button';
  import { Input } from '$ui/primitives/Input';

  let {
    onClose,
    onJoined
  }: {
    onClose: () => void;
    onJoined: () => void;
  } = $props();

  let code = $state('');
  let busy = $state(false);
  let message = $state<string | null>(null);

  async function submit(): Promise<void> {
    const trimmed = code.trim().toUpperCase();
    if (trimmed.length < 1 || busy) return;
    busy = true;
    message = null;
    try {
      const res = await joinGroupByCode(trimmed);
      if (res.ok) {
        onJoined();
        onClose();
      } else if (res.error === 'invalid_code') {
        message = t('groups.invalidCode');
      } else if (res.error === 'already_member') {
        message = t('groups.alreadyMember');
      } else {
        message = t('groups.joinError');
      }
    } finally {
      busy = false;
    }
  }

  let open = $state(true);
</script>

<Modal
  bind:open
  title={t('groups.joinTitle')}
  size="sm"
  onclose={onClose}
>
  <div class="body">
    <Input
      type="text"
      maxlength={12}
      label={t('groups.code')}
      placeholder={t('groups.codePlaceholder')}
      bind:value={code}
      spellcheck={false}
      autocomplete="off"
      error={message ?? undefined}
      onkeydown={(e) => e.key === 'Enter' && void submit()}
    />
  </div>

  {#snippet footer()}
    <Button variant="outline" disabled={busy} onclick={onClose}>
      {t('groups.cancel')}
    </Button>
    <Button
      variant="filled"
      loading={busy}
      disabled={busy || code.trim().length < 1}
      onclick={() => void submit()}
    >
      {busy ? t('groups.joining') : t('groups.join')}
    </Button>
  {/snippet}
</Modal>

<style>
  .body {
    display: flex;
    flex-direction: column;
    gap: var(--space-3);
  }
</style>